"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContribConfig = void 0;
var kaltura_player_utils_1 = require("./kaltura-player-utils");
function getContribConfig(player, path, baseConfig, options) {
    return kaltura_player_utils_1.KalturaPlayerUtils.getPlayerConfig(player, "contrib.".concat(path), baseConfig, 
    // @ts-ignore
    options);
}
exports.getContribConfig = getContribConfig;
//# sourceMappingURL=contrib-utils.js.map